import React from 'react';
import { FadeIn, CtaButton, PricePill } from './ui';
import { IMAGES } from './constants';
export function FinalCta() {
  return <section className="relative w-full overflow-hidden px-6 py-24 sm:py-32" data-id="element-25">
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(135deg, #1B2B4A 0%, #2D4A6E 100%)'
    }} aria-hidden="true" data-id="element-26" />
      <img src={IMAGES.finalCta} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" data-id="element-27" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-28">
        <FadeIn data-id="element-29">
          <h2 className="font-serif text-4xl leading-tight text-white sm:text-5xl" data-id="element-30">
            El primer paso es el más difícil. Después es solo hablar.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg text-white/70" data-id="element-31">
            Hoy puede ser el día en que te des ese espacio que venís
            postergando.
          </p>
          <div className="mt-8" data-id="element-32">
            <PricePill data-id="element-33" />
          </div>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-34">
            <CtaButton variant="primary" data-id="element-35">Quiero hablar ahora →</CtaButton>
            <CtaButton variant="secondary" data-id="element-36">📅 Elegir mi turno →</CtaButton>
          </div>
          <p className="mt-6 text-sm text-white/60" data-id="element-37">
            🔒 Tu privacidad siempre protegida.
          </p>
        </FadeIn>
      </div>
    </section>;
}